import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URL } from './base-url';

@Injectable({
  providedIn: 'root'
})
export class TpmService {

  constructor(public http: HttpClient) { }

  base_URL = BASE_URL;

  cid: any = sessionStorage.getItem("cid");

  registerOptions(body: any) {
    return this.http.post(this.base_URL + 'users/tpm/register/options', body);
  }

  registerOtp(body: any) {
    return this.http.post(this.base_URL + 'users/tpm/register/otp', body);
  }

  registerVerify(body: any) {
    return this.http.post(this.base_URL + 'users/tpm/register/verify', body);
  }

  loginVerify(body: any) {
    return this.http.post(this.base_URL + 'users/tpm/login/verify', body);
  }

  loginOptions(email: any, cid: any) {
    return this.http.post(this.base_URL + `users/tpm/login/options?email=${email}&cid=${cid}`, {});
  }

}
